/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_ALL_REBATE_PROGRAMS = 'GET_ALL_REBATE_PROGRAMS';
export const SET_DETAIL_SCREEN = 'SET_DETAIL_SCREEN';
export const SET_CREATE_UTIL_TAPE_DATA = 'SET_CREATE_UTIL_TAPE_DATA';
export const GET_MANUFACTURERS_BY_PQR = 'GET_MANUFACTURERS_BY_PQR';
export const CALCULATE_INVOICE = 'CALCULATE_INVOICE';
export const SET_DEFAULT_QTR = 'SET_DEFAULT_QTR';
export const SET_CMS_REPORTING_GRPS = 'SET_CMS_REPORTING_GRPS';
export const REBATE_PRGBY_CMS = 'REBATE_PRGBY_CMS';
export const SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES';
export const RESET_CREATE_UTILIZATION_TAP_STORE =
  'RESET_CREATE_UTILIZATION_TAP_STORE';

export const CREATE_CORRECT_CMS_GET_REPORT_QUARTER =
  'CREATE_CORRECT_CMS_GET_REPORT_QUARTER';
export const INVOICE_START_QTR = 'INVOICE_START_QTR';
export const GET_PREVIOUS_QTR = 'GET_PREVIOUS_QTR';
export const SAVE_CMS_QTR_REPORT = 'SAVE_CMS_QTR_REPORT';
export const SET_CMS64_DATA = 'SET_CMS64_DATA';
export const GET_MAXQUARTER_FOR_CMS_REPORT = 'GET_MAXQUARTER_FOR_CMS_REPORT';
export const UPDATE_CORRECT_CMS_GET_REPORT_QUARTER =
  'UPDATE_CORRECT_CMS_GET_REPORT_QUARTER';
export const CREATE_CMS_EXTRA_STATE = 'CREATE_CMS_EXTRA_STATE';
export const CLEAR_CREATE_CMS_TAB = 'CLEAR_CREATE_CMS_TAB';
export const RSCH_CMS_QTR_REPORT = 'RSCH_CMS_QTR_REPORT';
export const PAYMENTS_DATA = 'PAYMENTS_DATA';
export const CMS_API_RESPONE = 'CMS_API_RESPONE';
